import { getBillsSetup, getBillsList, deleteBillsDetails } from '@/services/bills.js'
import jsonData from './jsonData.js'
import allButton from '@/components/allButton'
import searchForm from '@/components/searchForm'
import createTable from '@/components/createTable'
import dialogEffect from '@/components/dialogEffect'
import { mixin } from '@/mixins/mixin'
export default {
  name: 'BillList',
  mixins: [mixin],
  components: {
    searchForm,
    createTable,
    allButton,
    dialogEffect
  },
  data () {
    return {
      tableDataItem: jsonData.tableDataItem,
      isTabChange: false,
      total_amount: 0,
      total_paid: 0,
      total_refund: 0,
      total_waived: 0,
      total_unpaid: 0
    }
  },
  watch: {
    $route (to, from) {}
  },
  created () {
    this.queryData(getBillsSetup)
  },
  activated () {
    if (this.isActive) this.queryData(getBillsSetup)
    this.isActive = true
  },
  methods: {
    // 点击操作按钮
    async handleClick (type, data) {
      if (type?.action === 'view') {
        this.$router.push({
          name: 'billsManagerDetail',
          params: {
            id: data.id.value
          }
        })
      }
      if (type?.action === 'destroy') {
        this.deleteClick(data, deleteBillsDetails)
      }
    },
    handleSwitchChange (data) {},
    forwardToPage (data, name) {
      if (name === 'user') {
        this.$router.push({
          name: 'memberDetail',
          params: {
            id: data.id
          }
        })
      }
    },
    tabChange (index) {
      this.isTabChange = true
      const params = {
        scope: this.tabData[index].value
      }
      this.queryData(getBillsSetup, params)
    },
    // 查询
    search (data) {
      if (this.isTabChange) {
        this.isTabChange = false
        return
      }
      if (data) this.searchData = data
      const { page, per_page } = this.pageData
      Object.assign(this.searchData, { page, per_page })
      this.loading = true
      getBillsList(this.searchData).then(res => {
        if (res.data) {
          this.tableData = res.data.objects
          this.tabData = res.data.scopes
          this.total_amount = (res.data.total_amount / 100).toFixed(2)
          this.total_paid = (res.data.total_paid / 100).toFixed(2)
          this.total_waived = (res.data.total_waived / 100).toFixed(2)
          this.total_unpaid = (res.data.total_unpaid / 100).toFixed(2)
          this.total_refund = (res.data.total_refund / 100).toFixed(2)
          Object.assign(this.pageData, res.data.pagination)
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
